<template>
  <div class="  con_content">
    <div class="container">
      <div class="container_top h_48">
        合辑列表
      </div>

      <div>
        <!-- table组件 -->
        <div class="my_table">
          <!-- <Header class="my_title txt_l">
                        <span class='my_titleL'>
                            <Icon class="fw_900 " type="ios-list" size='30'/>     
                            筛选查询
                        </span>
                    </Header> -->
          <div class="my_search" style="margin-bottom:20px">
            <Row class="search_row">
              <div class="search_name">
                <Button
                  class="mR5"
                  type="info"
                  @click="
                    route = '/layout/circle/banner/add';
                    mTitle = '添加合辑';
                    rBtn = '添加';
                    addFun();
                  "
                >
                  <Icon type="md-add" />添加</Button
                >
              </div>
            </Row>
          </div>
          <div class="my_search">
            <Row class="search_row">
              <div class="search_name">
                合辑名称:
              </div>

              <Col span="4">
                <Input
                  ref="isFocuseA"
                  :maxlength="50"
                  class="ipt top13"
                  placeholder="请输入合辑名称"
                  @keyup.enter.native="searchFun"
                  v-model="search"
                >
                  <Button
                    size="small"
                    @click="searchFun"
                    slot="append"
                    icon="md-search"
                  ></Button>
                </Input>
              </Col>
            </Row>
          </div>
        </div>
        <!-- table组件 -->
        <div class="my_table  ">
          <Header class="my_title txt_l">
            <span class="my_titleL">
              <Icon class="fw_900 " type="ios-list" size="30" />
              数据列表
            </span>

            <div class="ct_rgt">
              <!-- <div class="sta_btn " type="primary"   @click="exportData">导出数据</div> -->
            </div>
          </Header>
          <Table border :columns="columns1" :data="data1" ref="table">
            <!-- 图片 -->
            <template slot-scope="{ row }" slot="thumb">
              <div class="img_c">
                <img v-if="row.thumb" :src="row.thumb" alt="" />
              </div>
            </template>
            <!-- 展示类型 -->
            <template slot-scope="{ row }" slot="type">
              <span v-if="row.type == 0">动态</span>
              <span v-if="row.type == 1">商城</span>
            </template>

            <!-- 按钮 -->
            <template slot-scope="{ row }" slot="btn">
              <!-- <Poptip trigger="hover" :title="row.surname" content="查看"> -->

              <Poptip trigger="hover" content="推荐">
                <Button
                  class="padlr5"
                  size="small"
                  @click="
                    route = '/layout/circle/banner/edit';
                    recBool = true;
                    rec.recRow = row;
                  "
                  type="primary"
                  icon="ios-compass-outline"
                ></Button>
              </Poptip>
              <Poptip trigger="hover" content="编辑">
                <Button
                  class="padlr5"
                  size="small"
                  @click="
                    route = '/layout/circle/banner/edit';
                    mTitle = '编辑合辑';
                    rBtn = '修改';
                    editFun(row);
                  "
                  type="success"
                  icon="md-open"
                ></Button>
              </Poptip>
              <Poptip trigger="hover" content="删除">
                <Button
                  class="padlr5"
                  size="small"
                  @click="
                    route = '/layout/circle/banner/del';
                    delFun(row);
                  "
                  type="error"
                  icon="md-close"
                ></Button>
              </Poptip>
            </template>
          </Table>
          <Footer>
            <Page
              :current.sync="page.page"
              :total="page.total"
              :page-size="page.size"
              @on-change="change_page"
              @on-page-size-change="change_size"
              show-total
              show-sizer
            />
          </Footer>

          <!-- 编辑轮播 -->
          <Modal
            v-model="modal1"
            :title="mTitle"
            class-name="vertical-center-modal"
          >
            <div slot="footer">
              <Button type="text" size="large" @click="cancel">取消</Button>
              <Button
                type="primary"
                size="large"
                v-if="mTitle == '添加合辑'"
                @click="addSubmit"
                >添加</Button
              >
              <Button
                type="primary"
                size="large"
                v-if="mTitle == '编辑合辑'"
                @click="editSubmit"
                >修改</Button
              >
            </div>
            <ul class="list_ul">
              <!-- 合辑标题-->
              <li>
                <div class="list_title">
                  <span class="cRed">*</span> 合辑标题 :
                </div>
                <div class="list_con">
                  <Input
                    v-model="submit.title"
                    type="text"
                    class="ipt"
                    placeholder="请输入合辑标题"
                  />
                </div>
              </li>
              <!-- 上级类目 -->
              <li>
                <div class="list_title">
                  <span class="cRed">*</span> 上级类目 :
                </div>
                <div class="list_con relative">
                  <!-- 子组件 -->
                  <myselect 
                    :select="submit.parent"
                    :selects="cateId.selects"
                    @selectChild="selectChild"
                  ></myselect>
                  
                </div>
              </li>

              <!-- 当前图片-->
              <li>
                <div class="list_title">当前图片 :</div>
                <div class="list_con imgS">
                  <img :src="submit.thumb" v-if="submit.thumb" alt="" />
                  <img
                    src="../../../../public/images/head_01.png"
                    v-if="!submit.thumb"
                    alt=""
                  />
                </div>
              </li>

              <!-- 轮播图片 model5 -->
              <li>
                <div class="list_title"><span class="cRed">*</span> 图片 :</div>
                <div class="list_con">
                  <cropper @childFun="childFun2" :data="cropper_data"></cropper>
                </div>
              </li>

              <!-- 排序 -->
              <li>
                <div class="list_title"><span class="cRed">*</span> 排序 :</div>
                <div class="list_con">
                  <InputNumber
                    type="number"
                    class="ipt"
                    placeholder="请输入排序"
                    v-model="submit.listorder"
                  />
                </div>
              </li>

              <!-- 状态 -->
              <li>
                <div class="list_title">状态 :</div>
                <div class="list_con">
                  <i-switch
                    class="mSwitch"
                    v-model="submit.display"
                    :true-value="1"
                    :false-value="0"
                    @on-change="change_btn"
                  />
                </div>
              </li>
            </ul>
          </Modal>
          <!-- 确认删除框 -->
          <Modal
            v-model="delM"
            title="提示"
            @on-ok="delOk"
            class-name="vertical-center-modal"
          >
            <p>确定删除吗?</p>
          </Modal>
          <!-- 推荐 -->
          <Modal
            v-model="recBool"
            title="推荐合辑"
            @on-ok="delOk"
            class-name="vertical-center-modal"
          >
            <div slot="footer">
              <Button type="text" size="large" @click="cancel">取消</Button>
              <Button type="primary" size="large" @click="recommendFun(row)"
                >推荐</Button
              >
            </div>
            <CheckboxGroup v-model="rec.recCheck" @on-change="recChange">
              <Checkbox
                v-for="(item, index) in rec.recAll"
                :key="index"
                :label="item.id"
                border
                >{{ item.title }}</Checkbox
              >
            </CheckboxGroup>
          </Modal>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";
import { format } from "path";
import CryptoJS from "crypto-js";
import cropper from "../../child_vue/vue_cropper.vue";
import myselect from "../../child_vue/select.vue";

const submitInit = {
  id: "",
  cateId: "",
  listorder: 0,
  thumb: "",
  title: "",
  display: 1
};

export default {
  name: "guanliyuan",
  data() {
    return {
      guid: null,
      route: null,
      token: "",
      search: "",
      rec: {
        //推荐选择
        recRow: null,
        recCheck: [],
        recAll: []
      },

      columns1: [],
      mTitle: "",
      rBtn: "",
      data1: [],
      page: {
        page: 1,
        size: 10,
        total: 0
      },

      checkGuid2: "",

      val: -1,

      modal1: false, //添加弹窗
      recBool: false, //推荐弹窗

      submit: submitInit,

      delM: false,

      type: [], //所属上级
      type2: [
        //展示类型
        { code: "0", name: "动态" },
        { code: "1", name: "商城" }
      ],

      image_back: null, //上传图片后返回值

      cropper_data: {
        btn_name: "上传图片",
        outputType: "jpeg", //生成图片格式
        type: "18", //图片分组
        vCropper: "5", //插件分组
        enlarge: "1", //倍数
        autoCropWidth: "200",
        autoCropHeight: "200"
      },

      child_val: null, //child 反馈
      cateId: {
        select: "",
        selects: []
      }
    };
  },
  created() {
    this.selectFun();
    this.recFun();
  },
  watch: {},
  components: { cropper, myselect },
  props: ["uploadType"],
  computed: {
    is_change_layout() {
      return this.$store.getters.is_change_layout;
    },
    is_change_vCropper() {
      return this.$store.getters.is_change_vCropper;
    }
  },

  methods: {
    recFun() {
      this.$myAjax
        .get(
          `admin/service/album/getAllRecomCate?route=/layout/jurisdiction/admin/editor`
        )
        .then(res => {
          this.rec.recAll = res.data.data;
          // console.log(res.data.data);
        });
    },
    selectFun() {
      this.$myAjax
        .get(`admin/cate?route=/layout/jurisdiction/admin/editor`)
        .then(res => {
          this.cateId.select = res.data.data[0].label;
          let selects = res.data.data;

          function fun(opt) {
            for (let i = 0; i < opt.length; i++) {
              opt[i].title = opt[i].label;
              if (opt[i].children && opt[i].children.length > 0) {
                fun(opt[i].children);
              }
            }
          }
          fun(selects);
          this.cateId.selects = selects;
        });
    },

    load() {
      var that = this;

      that.$myAjax
        .get(
          `admin/service/album/list?page=${that.page.page}&&size=${that.page.size}&&route=/layout/jurisdiction/admin/edit`
        )
        .then(res => {
          that.page.total = res.data.data.total;
          that.data1 = res.data.data.list;

          that.columns1 = [
            { title: "ID", key: "id", align: "center", width: 80 },
            {
              title: "所属上级",
              key: "parent",
              align: "center",
              minWidth: 100
            },
            { title: "标题", key: "title", align: "center", minWidth: 100 },
            { title: "图片", slot: "thumb", align: "center", width: 150 },
            { title: "排序", key: "listorder", align: "center", width: 80 },
            { title: "播放量", key: "playNum", align: "center", width: 80 },
            {
              title: "状态",
              key: "display",
              align: "center",
              width: 110,
              render: (h, params) => {
                return h(
                  "i-switch",
                  {
                    props: {
                      size: "large",
                      value: params.row.display == "1"
                    },
                    on: {
                      "on-change": value => {
                        that.$myAjax
                          .put(
                            "admin/service/album/changeStatus?route=/layout/circle/banner/edit",
                            {
                              id: params.row.id,
                              display: value
                            }
                          )
                          .then(res => {
                            that.load();
                          })
                          .catch(err => {
                            console.log(err);
                          });
                      }
                    }
                  },
                  [
                    h("span", {
                      slot: "open",
                      domProps: {
                        innerHTML: "开启"
                      }
                    }),
                    h("span", {
                      slot: "close",
                      domProps: {
                        innerHTML: "关闭"
                      }
                    })
                  ]
                );
              }
            },
            {
              title: "创建日期",
              key: "createTime",
              align: "center",
              minWidth: 100
            },
            {
              title: "操作",
              slot: "btn",
              align: "center",
              width: 180,
              fixed: "right"
            }
          ];

          that.$data_null.editor(that.data1);
        });
    },
    recChange(opt) {
      this.rec.recCheck = opt;
    },
    searchFun() {
      if (this.search) {
        this.$myAjax
          .get(
            `admin/service/album/search?page=${this.page.page}&&size=${this.page.size}&&title=${this.search}&&route=/layout/jurisdiction/admin/edit`
          )
          .then(res => {
            this.page.total = res.data.data.total;
            this.data1 = res.data.data.list;
          });
      } else {
        this.load();
      }
    },
    change_page() {
      this.load();
    },
    change_size(size) {
      this.size = size;
      this.load();
    },
    // 编辑
    editFun(res) {
      this.modal1 = true;
      this.submit = res;
   
      this.$canBtn(this.route).then(function(res_c) {});
    },

    //    编辑弹窗
    editSubmit() {
      var that = this;

      let data = this.submit;
      // this.$data_null.del(data);
      if (!data.title) {
        that.$Message.info({
          content: "请输入合辑标题",
          duration: 3
        });
      } else if (!data.cateId) {
        that.$Message.info({
          content: "请输入上级类目",
          duration: 3
        });
      } else if (!data.thumb) {
        that.$Message.info({
          content: "请上传图片",
          duration: 3
        });
      } else if (!data.listorder && data.listorder != 0) {
        that.$Message.info({
          content: "请输入排序",
          duration: 3
        });
      } else {
        if (!that.child_val) {
          that.$myAjax
            .put("admin/service/album/edit?route=" + that.route, data)
            .then(res => {
              if (res.data.code != 0) {
                that.load();
                that.cancel();
              }
            });
        } else {
          that.$upload(that.child_val).then(res => {
            that.submit.thumb = res.data.data.path;
            that.$myAjax
              .put("admin/service/album/edit?route=" + that.route, data)
              .then(res => {
                if (res.data.code != 0) {
                  that.load();
                  that.cancel();
                }
              });
          });
        }
      }
    },
    cancel() {
      this.modal1 = false;
    },

    // 删除用户组
    delFun(res) {
      let that = this;

      that.guid = res.id;
      that.delM = true;
      that.$canBtn(that.route).then(function(res_c) {});
    },
    delOk() {
      let that = this;
      that.$myAjax
        .delete(
          "admin/service/album/del?id=" + that.guid + "&route=" + that.route,
          {
            guid: that.guid
          }
        )
        .then(res => {
          that.load();
        });
    },

    // 顶部添加

    addFun(route) {
      this.modal1 = true;
      this.submit = submitInit;
      this.$canBtn(this.route).then(function(res_c) {});
    },
    addSubmit() {
      let that = this;
      let data = that.submit;
      if (!data.title) {
        that.$Message.info({
          content: "请输入合辑标题",
          duration: 3
        });
      } else if (!data.cateId) {
        that.$Message.info({
          content: "请输入上级类目",
          duration: 3
        });
      } else if (!that.child_val) {
        that.$Message.info({
          content: "请上传图片",
          duration: 3
        });
      } else if ( !data.listorder && data.listorder != 0  ) {
        that.$Message.info({
          content: "请输入排序",
          duration: 3
        });
      } else {
        that.$upload(that.child_val).then(res => {
          data.thumb = res.data.data.name;
          that.$myAjax
            .post("admin/service/album/add?route=" + that.route, data)
            .then(res => {
              if (res.data.code != 0) {
                that.load();
                that.cancel();
              }
            });
        });
      }
    },
    cancel_add() {
      this.modal2 = false;
    },
    // 提交按钮
    change() {},
    change_btn(bool) {},
    recommendFun() {
      this.$myAjax
        .post("admin/service/album/setRecom?route=" + this.route, {
          checkedCates: this.rec.recCheck,
          id: this.rec.recRow.id
        })
        .then(res => {
          if (res.data.code != 0) {
            this.load();
            this.recBool = false;
          }
        });
    },
    selectChild(opt) {
      this.submit.cateId = opt[0].id;
    },
    // 剪切上传
    childFun2(data) {
      let that = this;
      that.child_val = data.pic_url;
    }
  },
  mounted: function() {
    var that = this;
    that.token = that.$store.state.token;

    that.vCropper = that.$store.state.vCropper;

    that.load();
  }
};
</script>
<style scoped>
.list_ul li {
  padding: 5px 10px !important;
}
/* 表格下方无翻页按钮时 */
.ivu-table-wrapper {
  margin-bottom: 50px;
}

.dis_none {
  display: none;
}

/* 弹窗 */
.list_ul {
  width: 100%;
  height: auto;
}
.list_ul li {
  width: 100%;
  height: auto;
  overflow: hidden;
  padding: 5px 0;
}
.list_ul .list_title {
  float: left;
  width: 26%;
  text-align: right;
  padding-right: 10px;
  line-height: 32px;
  font-size: 14px;
}
.list_ul .list_con {
  float: left;
  width: 60%;
}

.img_c {
  position: relative;
  display: inline-block;
  width: 100px;
  height: 40px;
  border-radius: 3px;
  overflow: hidden;
  white-space: nowrap;
  text-align: center;
  vertical-align: middle;
}
.img_c img {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  height: 40px;
}
</style>



